import React from "react";
import { FilterOutlined, SearchOutlined } from "@ant-design/icons";

interface TableFiltersProps {
  onStatusFilter: (value: string) => void;
  statusFilter: string;
}

export const TableFilters: React.FC<TableFiltersProps> = ({
  onStatusFilter,
  statusFilter,
}) => {
  return (
    <div className="filters-container">
      <div className="filter-container">
        <FilterOutlined />
        <select
          className="filter-select"
          value={statusFilter}
          onChange={(e) => onStatusFilter(e.target.value)}
        >
          <option value="">All</option>
          <option value="completed">Completed</option>
          <option value="pending">Pending</option>
        </select>
      </div>
    </div>
  );
};
